import * as React from "react"

import { cn } from "@/lib/utils"

const CardBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-xl border bg-card text-card-foreground shadow",
      className
    )}
    {...props}
  />
))
CardBase.displayName = "Card"

const CardHeaderBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
))
CardHeaderBase.displayName = "CardHeader"

const CardTitleBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("font-semibold leading-none tracking-tight", className)}
    {...props}
  />
))
CardTitleBase.displayName = "CardTitle"

const CardDescriptionBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
))
CardDescriptionBase.displayName = "CardDescription"

const CardContentBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContentBase.displayName = "CardContent"

const CardFooterBase = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
))
CardFooterBase.displayName = "CardFooter"

// --- uiv2: conditional Intui swap (build-time resolved by Vite) ---
import {
  IntuiCard,
  IntuiCardHeader,
  IntuiCardTitle,
  IntuiCardDescription,
  IntuiCardContent,
  IntuiCardFooter,
} from '@/components/intueri/IntuiCard'

const _uiv2 = import.meta.env.VITE_UIV2 === 'true'
const Card = _uiv2 ? (IntuiCard as typeof CardBase) : CardBase
const CardHeader = _uiv2 ? (IntuiCardHeader as typeof CardHeaderBase) : CardHeaderBase
const CardFooter = _uiv2 ? (IntuiCardFooter as typeof CardFooterBase) : CardFooterBase
const CardTitle = _uiv2 ? (IntuiCardTitle as typeof CardTitleBase) : CardTitleBase
const CardDescription = _uiv2 ? (IntuiCardDescription as typeof CardDescriptionBase) : CardDescriptionBase
const CardContent = _uiv2 ? (IntuiCardContent as typeof CardContentBase) : CardContentBase

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
